export const FALLBACKLNG = ["en"];
/*export const AVAILABLELANGUAGES = [
    {id:0, lang:'en'},
    {id:1, lang:'ru'},
    {id:2, lang:'it'}];*/
export const AVAILABLELANGUAGES = window.Bagbnb
  ? window.Bagbnb.locales
  : [
      {
        apiUriprefix: "en",
        baseAirportTransferPrefix: "/airport-transfers/",
        baseLuggageStoragePrefix: "/luggage-storage/",
        htmlUriPrefix: "",
        id: "en",
        locale: "en-GB",
        name: "English",
        weight: 0,
      },
    ];

export const API =
  (window.Bagbnb && window.Bagbnb.apiUrl) || "https://api.storage.radical.run/";
export const ANGEL_APP_CALENDAR_URL =
  window.Bagbnb && window.Bagbnb.angelAppCalendarUrl;
export const BOOKING_API =
  (window.Bagbnb && window.Bagbnb.bookingApiUrl) ||
  "https://api.storage.radical.run/bookings/";
export const ORGANIZATION_API =
  (window.Bagbnb && window.Bagbnb.organizationApiUrl) ||
  "https://api.storage.radical.run/organization/";
export const API_CATALOG_API =
  (window.Bagbnb && window.Bagbnb.catalogApiUrl) ||
  "https://api.storage.radical.run/api-catalog/";
export const API_V3 =
  (window.Bagbnb && window.Bagbnb.apiV3Url) ||
  "https://storage.radical.run/v3/";
export const DOMAIN =
  (window.Bagbnb && window.Bagbnb.domain) || "https://storage.radical.run";
export const SENTRY =
  (window.Bagbnb && window.Bagbnb.sentry) ||
  "https://50e00349cdaf4355a6b271b89dbcd830@o165309.ingest.sentry.io/5219271";
export const assetsStaticURL = "https://assets.radical.storage/static/";

export const baseURL =
  (window.Bagbnb && window.Bagbnb.domain.split("//")[1]) ||
  "stg.radical.storage";

export const MAP_TILER_KEY =
  (window.Bagbnb && window.Bagbnb.mapTilerKey) || "FzrTVDWnzVpPaUgUUXYo";

/*export const API = 'https://api.bagbnb.com/';
export const API_V3 = 'https://bagbnb.com/v3/';
export const DOMAIN = 'http://bagbnb.local';*/

export const PUBLIC_URL = process.env.PUBLIC_URL;

//export const COMPANY_STATIC_FIELDS = ["name", "country", "address", "email", "owner", "vat"]; deprecated old API logic
export const COMPANY_STATIC_FIELDS = [
  "vat",
  "country",
  "company_name",
  "owner",
  "address",
  "city",
  "district",
  "postal_code",
  "unique_code",
];
export const COMPANY_DEFAULT_COUNTRY = "it";
export const OLD_COMPANY_DYNAMIC_FIELDS = [
  "fiscal_code",
  "nif",
  "cuil_cuit",
  "unique_code",
  "certified_email",
  "vat",
  "italian_province",
]; //should be deprecated old API logic
export const COMPANY_DYNAMIC_FIELDS = ["italian_province", "certified_email"];
export const COMPANY_FIELDS_NAMES = {
  account_number: {
    label: "Account number",
    placeholder: "Insert your Account number",
  },
  bik: { label: "BIK", placeholder: "Insert your BIK" },
  bank_account_name: {
    label: "Account holder",
    placeholder: "Insert your Bank account name",
  },
  // vat: { label: "VAT", placeholder: 'Insert your VAT' },
  iban: { label: "IBAN", placeholder: "Insert your IBAN" },
  cuil_cuit: { label: "Cuil cuit", placeholder: "Insert your Cuil cuit" },
  branch: { label: "Branch", placeholder: "Insert your Branch" },
  paypal_account: {
    label: "Paypal account",
    placeholder: "Insert your Paypal account",
  },
  bsb_code: { label: "BSB code", placeholder: "Insert your BSB code" },
  business_number: {
    label: "Business number",
    placeholder: "Insert your Business number",
  },
  krw_account_number: {
    label: "KRW account number",
    placeholder: "Insert your KRW account number",
  },
  nif: { label: "NIF", placeholder: "Insert your NIF" },
  fiscal_code: { label: "Fiscal code", placeholder: "Insert your Fiscal code" },
  bank_name: { label: "Bank name", placeholder: "Insert your Bank name" },
  routing_number: {
    label: "Routing number",
    placeholder: "Insert your Routing number",
  },
  credit_card: { label: "Credit Card", placeholder: "Insert your Credit card" },
  institution_number: {
    label: "Institution number",
    placeholder: "Insert your Institution number",
  },
  transit_number: {
    label: "Transit number",
    placeholder: "Insert your Transit number",
  },
  account_type: {
    label: "Account type",
    placeholder: "Insert your Account type",
  },
  sort_code: { label: "Sort code", placeholder: "Insert your Sort code" },
  unique_code: { label: "Unique code", placeholder: "Insert your Unique code" },
  certified_email: {
    label: "Certified email",
    placeholder: "Insert your Certified email",
  },
  phone: { label: "Phone number", placeholder: "Insert your Phone number" },
  recipient_bank_name: {
    label: "Recipient bank name",
    placeholder: "Insert your Recipient bank name",
  },
  account_holder_cyrillic: {
    label: "Account holder cyrillic",
    placeholder: "Insert your Account holder cyrillic",
  },
  e_wallet: { label: "E-Wallet", placeholder: "Insert your E-Wallet" },
  e_wallet_recipient_num: {
    label: "Recipient E-wallet number",
    placeholder: "Insert your recipient E-wallet number",
  },
  recipient_dob: {
    label: "Recipient's date of birth",
    placeholder: "Insert recipient's date of birth ",
    type: "date",
  },
  document_type: {
    label: "ID document type",
    placeholder: "Insert ID document type",
  },
  rut_number: { label: "RUT number", placeholder: "Insert RUT number" },
  recipient_id_number: {
    label: "Recipient's identification number",
    placeholder: "Insert recipient's identification number",
  },
  cnpj: {
    label: "CNPJ",
    placeholder: "Insert Branch code Tax registration number (CNPJ)",
  },
  uen: { label: "Unique Entity Number (UEN)", placeholder: "Insert UEN" },
  rfc: { label: "RFC", placeholder: "Insert RFC" },
  curp: { label: "CURP", placeholder: "insert CURP" },
  fedwire_number: {
    label: "Fedwire number",
    placeholder: "Insert Fedwire number",
  },
  fedwire_routing_number: {
    label: "Fedwire routing number",
    placeholder: " Insert Fedwire routing number",
  },
  italian_province: {
    label: "Italian province",
    placeholder: "Insert italian province",
  },
};
export const COMPANY_FIELDS_BY_COUNTRY = {
  ad: ["bank_account_name", "iban", "paypal_account"],
  ae: ["bik", "bank_account_name", "iban", "paypal_account"],
  al: ["vat", "iban", "bank_account_name", "paypal_account"],
  am: [
    "account_number",
    "bik",
    "bank_account_name",
    "paypal_account",
    "fedwire_number",
    "fedwire_routing_number",
    "routing_number",
  ],
  ar: ["cuil_cuit", "account_number", "bank_account_name", "paypal_account"],
  at: ["vat", "bik", "bank_account_name", "iban", "paypal_account"],
  au: [
    "account_number",
    "bank_account_name",
    "business_number",
    "bsb_code",
    "paypal_account",
  ],
  bb: [
    "bank_name",
    "account_number",
    "bank_account_name",
    "bik",
    "paypal_account",
  ],
  ba: ["vat", "bik", "bank_account_name", "iban", "paypal_account"],
  be: ["vat", "bik", "bank_account_name", "iban", "paypal_account"],
  bg: ["vat", "nif", "bik", "bank_account_name", "iban", "paypal_account"],
  bh: [
    "iban",
    "bank_account_name",
    "paypal_account",
    "fedwire_number",
    "fedwire_routing_number",
    "account_number",
    "routing_number",
  ],
  br: [
    "vat",
    "fiscal_code",
    "account_number",
    "bik",
    "bank_name",
    "bank_account_name",
    "iban",
    "credit_card",
    "branch",
    "paypal_account",
    "cnpj",
  ],
  ca: [
    "vat",
    "account_number",
    "bank_account_name",
    "institution_number",
    "transit_number",
    "paypal_account",
  ],
  ch: ["vat", "bik", "bank_account_name", "iban", "paypal_account"],
  cl: [
    "vat",
    "account_number",
    "bik",
    "bank_account_name",
    "paypal_account",
    "rut_number",
    "bank_name",
    "phone",
  ],
  cn: ["bank_account_name", "account_number", "bik"],
  co: [
    "bank_name",
    "bank_account_name",
    "account_number",
    "phone",
    "paypal_account",
    "fedwire_number",
    "fedwire_routing_number",
    "routing_number",
  ],
  cr: ["vat", "account_number", "bank_account_name", "bik"],
  cu: [
    "account_type",
    "bank_name",
    "bank_account_name",
    "account_number",
    "iban",
    "paypal_account",
  ],
  cy: ["vat", "iban", "bank_account_name", "paypal_account"],
  cz: ["vat", "bik", "bank_account_name", "iban", "paypal_account"],
  de: ["vat", "bik", "bank_account_name", "iban", "paypal_account"],
  dk: ["vat", "bik", "bank_account_name", "iban", "paypal_account"],
  do: ["bank_name", "bank_account_name", "account_number", "bik"],
  ec: [
    "vat",
    "account_number",
    "bank_name",
    "bik",
    "bank_account_name",
    "paypal_account",
    "fedwire_number",
    "fedwire_routing_number",
    "routing_number",
  ],
  ee: ["vat", "bik", "bank_account_name", "iban", "paypal_account"],
  eg: ["bank_name", "bank_account_name", "iban", "bik", "paypal_account"],
  es: ["vat", "bik", "bank_account_name", "iban", "nif", "paypal_account"],
  fi: ["vat", "nif", "bik", "bank_account_name", "iban", "paypal_account"],
  fr: [
    "vat",
    "fiscal_code",
    "bik",
    "bank_account_name",
    "iban",
    "paypal_account",
  ],
  ge: ["bank_account_name", "iban", "paypal_account"],
  gi: [
    "bank_account_name",
    "account_number",
    "bik",
    "paypal_account",
    "sort_code",
  ],
  gr: ["vat", "bik", "bank_account_name", "iban", "paypal_account"],
  gt: ["account_number", "bank_account_name", "paypal_account"],
  hk: [
    "vat",
    "account_number",
    "bank_name",
    "bank_account_name",
    "paypal_account",
  ],
  hr: ["vat", "bik", "bank_account_name", "iban", "paypal_account"],
  hu: ["vat", "bik", "bank_account_name", "iban", "paypal_account"],
  id: ["bank_account_name", "account_number", "bik"],
  ie: ["vat", "bik", "bank_account_name", "iban", "paypal_account"],
  il: ["vat", "iban", "bank_account_name", "credit_card", "paypal_account"],
  is: ["bank_account_name", "iban", "bik"],
  it: [
    "vat",
    "fiscal_code",
    "unique_code",
    "certified_email",
    "bank_account_name",
    "iban",
    "paypal_account",
    "italian_province",
  ],
  jo: ["iban", "bank_account_name", "paypal_account"],
  jp: [
    "vat",
    "account_number",
    "bank_name",
    "bik",
    "bank_account_name",
    "branch",
    "paypal_account",
  ],
  ke: [
    "bank_name",
    "account_number",
    "bank_account_name",
    "bik",
    "credit_card",
    "paypal_account",
  ],
  kr: [
    "vat",
    "bank_account_name",
    "krw_account_number",
    "bank_name",
    "recipient_bank_name",
    "bik",
    "phone",
    "paypal_account",
    "recipient_dob",
  ],
  lt: ["vat", "bik", "bank_account_name", "iban", "paypal_account"],
  lu: ["vat", "iban", "bank_account_name", "paypal_account"],
  lv: ["vat", "bik", "bank_account_name", "iban", "paypal_account"],
  ma: [
    "vat",
    "account_number",
    "bik",
    "bank_account_name",
    "bank_name",
    "paypal_account",
  ],
  me: ["vat", "iban", "bank_account_name", "paypal_account"],
  mk: ["vat", "bank_account_name", "iban"],
  mt: ["vat", "bik", "bank_account_name", "iban", "paypal_account"],
  mx: [
    "vat",
    "account_number",
    "bik",
    "bank_account_name",
    "paypal_account",
    "rfc",
    "curp",
  ],
  my: [
    "vat",
    "account_number",
    "bank_name",
    "bank_account_name",
    "recipient_bank_name",
    "paypal_account",
    "bik",
  ],
  nl: ["vat", "bik", "bank_account_name", "iban", "paypal_account"],
  no: ["vat", "bik", "bank_account_name", "iban", "paypal_account"],
  np: [
    "account_number",
    "bank_name",
    "bank_account_name",
    "phone",
    "paypal_account",
    "document_type",
    "recipient_id_number",
    "recipient_dob",
  ],
  nz: ["account_number", "bank_account_name", "paypal_account"],
  pe: [
    "vat",
    "account_number",
    "bank_account_name",
    "paypal_account",
    "phone",
    "document_type",
    "recipient_id_number",
    "recipient_dob",
    "bank_name",
  ],
  pf: [
    "vat",
    "account_number",
    "bik",
    "bank_account_name",
    "iban",
    "paypal_account",
  ],
  ph: [
    "vat",
    "account_number",
    "bank_name",
    "bank_account_name",
    "paypal_account",
    "e_wallet",
    "e_wallet_recipient_num",
  ],
  pl: ["vat", "nif", "bik", "bank_account_name", "iban", "paypal_account"],
  pt: ["vat", "bik", "bank_account_name", "iban", "paypal_account"],
  qa: ["account_number", "bank_account_name", "iban", "paypal_account"],
  ro: ["vat", "bik", "bank_account_name", "iban", "paypal_account"],
  rs: ["vat", "bik", "bank_account_name", "iban", "paypal_account"],
  ru: [
    "vat",
    "account_number",
    "bik",
    "account_holder_cyrillic",
    "bank_account_name",
    "credit_card",
    "paypal_account",
  ],
  se: ["vat", "bik", "bank_account_name", "iban", "paypal_account"],
  sg: [
    "vat",
    "account_number",
    "bik",
    "bank_name",
    "bank_account_name",
    "recipient_bank_name",
    "phone",
    "paypal_account",
    "uen",
  ],
  si: ["vat", "iban", "bank_account_name", "paypal_account"],
  sk: ["vat", "bik", "bank_account_name", "iban", "paypal_account"],
  sv: ["bank_account_name", "account_number"],
  th: [
    "account_number",
    "bank_name",
    "bank_account_name",
    "paypal_account",
    "bik",
  ],
  tr: ["vat", "bank_account_name", "iban", "credit_card", "paypal_account"],
  tw: [
    "bank_account_name",
    "account_number",
    "bank_name",
    "bik",
    "paypal_account",
  ],
  ua: [
    "vat",
    "nif",
    "account_number",
    "bik",
    "bank_account_name",
    "iban",
    "credit_card",
    "paypal_account",
  ],
  gb: [
    "vat",
    "account_number",
    "bank_account_name",
    "iban",
    "sort_code",
    "paypal_account",
  ],
  us: [
    "vat",
    "account_number",
    "bank_account_name",
    "routing_number",
    "paypal_account",
  ],
  vn: [
    "vat",
    "account_number",
    "bank_account_name",
    "credit_card",
    "paypal_account",
    "bik",
  ],
  uy: ["account_number", "bank_account_name", "bik"],
  xk: ["vat", "bik", "bank_account_name", "iban", "paypal_account"],
  za: [
    "vat",
    "account_number",
    "branch",
    "bank_name",
    "bank_account_name",
    "phone",
    "paypal_account",
  ],
};

export const MANDATORY_PAYMENT_FIELDS_BY_COUNTRY = {
  ad: ["bank_account_name", "iban"],
  ae: ["bank_account_name", "iban"],
  al: ["bank_account_name", "iban"],
  am: ["account_number", "bank_account_name", "routing_number"],
  ar: ["cuil_cuit", "bank_account_name", "account_number"],
  at: ["bank_account_name", "iban"],
  au: ["account_number", "bank_account_name", "bsb_code"],
  bb: ["bank_name", "account_number", "bank_account_name", "bik"],
  ba: ["bank_account_name", "iban"],
  be: ["bank_account_name", "iban"],
  bg: ["bank_account_name", "iban"],
  bh: ["bank_account_name", "account_number", "routing_number"],
  br: ["account_number", "bank_account_name", "bank_name", "branch"],
  ca: ["account_number", "bank_account_name", "institution_number"],
  ch: ["bank_account_name", "iban"],
  cl: [
    "account_number",
    "bank_account_name",
    "bank_name",
    "phone",
    "rut_number",
  ],
  cn: ["bank_account_name", "account_number", "bik"],
  co: ["bank_account_name", "account_number", "routing_number"],
  cr: ["account_number", "bank_account_name", "bik"],
  cu: ["bank_name", "bank_account_name", "account_number"],
  cy: ["iban", "bank_account_name"],
  cz: ["bank_account_name", "iban"],
  de: ["bank_account_name", "iban"],
  do: ["bank_name", "bank_account_name", "account_number", "bik"],
  dk: ["bank_account_name", "iban"],
  ec: [
    "account_number",
    "bank_name",
    "bik",
    "bank_account_name",
    "routing_number",
  ],
  ee: ["bank_account_name", "iban"],
  es: ["bank_account_name", "iban"],
  fi: ["bank_account_name", "iban"],
  fr: ["bank_account_name", "iban"],
  ge: ["bank_account_name", "iban"],
  gi: ["bank_account_name", "account_number", "sort_code"],
  gr: ["bank_account_name", "iban"],
  gt: ["account_number", "bank_account_name"],
  hk: ["account_number", "bank_name", "bank_account_name"],
  hr: ["bank_account_name", "iban"],
  hu: ["bank_account_name", "iban"],
  id: ["bank_account_name", "account_number", "bik"],
  ie: ["bank_account_name", "iban"],
  il: ["iban", "bank_account_name"],
  is: ["bank_account_name", "iban", "bik"],
  it: ["bank_account_name", "iban"],
  jp: ["account_number", "bik", "bank_account_name"],
  jo: ["iban", "bank_account_name"],
  ke: ["account_number", "bank_account_name", "bik", "bank_name"],
  kr: [
    "bank_account_name",
    "krw_account_number",
    "bank_name",
    "phone",
    "recipient_dob",
  ],
  lt: ["bank_account_name", "iban"],
  lu: ["iban", "bank_account_name"],
  lv: ["bank_account_name", "iban"],
  ma: ["account_number", "bank_account_name", "bank_name"],
  me: ["iban", "bank_account_name"],
  mk: ["bank_account_name", "iban"],
  mt: ["bank_account_name", "iban"],
  mx: ["bank_account_name", "account_number"],
  my: ["account_number", "bank_account_name", "bank_name", "bik"],
  nl: ["bank_account_name", "iban"],
  no: ["bank_account_name", "iban"],
  np: [
    "account_number",
    "bank_name",
    "bank_account_name",
    "phone",
    "document_type",
    "recipient_id_number",
  ],
  nz: ["account_number", "bank_account_name"],
  pe: [
    "account_number",
    "bank_account_name",
    "bank_name",
    "phone",
    "document_type",
    "recipient_id_number",
  ],
  pf: ["bank_account_name", "iban"],
  ph: ["bank_name", "account_number", "bank_account_name"],
  pl: ["bank_account_name", "iban"],
  pt: ["bank_account_name", "iban"],
  qa: ["bank_account_name", "iban"],
  ro: ["bank_account_name", "iban"],
  rs: ["bank_account_name", "iban"],
  ru: ["account_number", "bik", "account_holder_cyrillic", "bank_account_name"],
  se: ["bank_account_name", "iban"],
  sg: ["account_number", "bank_account_name", "bank_name"],
  si: ["iban", "bank_account_name"],
  sk: ["bank_account_name", "iban"],
  sv: ["bank_account_name", "account_number"],
  th: ["account_number", "bank_account_name", "bank_name"],
  tr: ["bank_account_name", "iban"],
  tw: ["bank_account_name", "account_number", "bank_name", "bik"],
  ua: ["bank_account_name", "iban"],
  gb: ["account_number", "bank_account_name", "sort_code"],
  us: ["account_number", "bank_account_name", "routing_number"],
  uy: ["account_number", "bank_account_name", "bik"],
  vn: ["account_number", "bank_account_name", "bik"],
  xk: ["bank_account_name", "iban"],
  za: ["account_number", "bank_name", "bank_account_name", "branch"],
};

export const EU_COUNTRIES = [
  "at",
  "be",
  "bg",
  "cy",
  "cz",
  "de",
  "dk",
  "ee",
  "es",
  "fi",
  "fr",
  "gr",
  "hr",
  "hu",
  "ie",
  //"it", // we are not sure but there are some conditions for EU_COUNTRIES and all tested without It inside this list
  "lt",
  "lu",
  "lv",
  "mt",
  "nl",
  "pl",
  "pt",
  "ro",
  "se",
  "si",
  "sk",
];

export const PAGINATION_PAGE_SIZE = {
  common: 10,
  orders: 5,
};

export const ITALIAN_PROVINCES = [
  { value: "-", label: "select province", isDisabled: true },
  { value: "TO", label: "Torino (province), Piemonte" },
  { value: "VC", label: "Vercelli (province), Piemonte" },
  { value: "NO", label: "Novara (province), Piemonte" },
  { value: "CN", label: "Cuneo (province), Piemonte" },
  { value: "AT", label: "Asti (province), Piemonte" },
  { value: "AL", label: "Alessandria (province), Piemonte" },
  { value: "BI", label: "Biella (province), Piemonte" },
  { value: "VB", label: "Verbano-Cusio-Ossola (province), Piemonte" },
  {
    value: "AO",
    label:
      "Valle d'Aosta/Vallée d'Aoste (province), Valle d'Aosta/Vallée d'Aoste",
  },
  { value: "VA", label: "Varese (province), Lombardia" },
  { value: "CO", label: "Como (province), Lombardia" },
  { value: "SO", label: "Sondrio (province), Lombardia" },
  { value: "MI", label: "Milano (province), Lombardia" },
  { value: "BG", label: "Bergamo (province), Lombardia" },
  { value: "BS", label: "Brescia (province), Lombardia" },
  { value: "PV", label: "Pavia (province), Lombardia" },
  { value: "CR", label: "Cremona (province), Lombardia" },
  { value: "MN", label: "Mantova (province), Lombardia" },
  { value: "LC", label: "Lecco (province), Lombardia" },
  { value: "LO", label: "Lodi (province), Lombardia" },
  { value: "MB", label: "Monza e della Brianza (province), Lombardia" },
  {
    value: "BZ",
    label: "Bolzano/Bozen (province), Trentino-Alto Adige/Südtirol",
  },
  { value: "TN", label: "Trento (province), Trentino-Alto Adige/Südtirol" },
  { value: "VR", label: "Verona (province), Veneto" },
  { value: "VI", label: "Vicenza (province), Veneto" },
  { value: "BL", label: "Belluno (province), Veneto" },
  { value: "TV", label: "Treviso (province), Veneto" },
  { value: "VE", label: "Venezia (province), Veneto" },
  { value: "PD", label: "Padova (province), Veneto" },
  { value: "RO", label: "Rovigo (province), Veneto" },
  { value: "UD", label: "Udine (province), Friuli-Venezia Giulia" },
  { value: "GO", label: "Gorizia (province), Friuli-Venezia Giulia" },
  { value: "TS", label: "Trieste (province), Friuli-Venezia Giulia" },
  { value: "PN", label: "Pordenone (province), Friuli-Venezia Giulia" },
  { value: "IM", label: "Imperia (province), Liguria" },
  { value: "SV", label: "Savona (province), Liguria" },
  { value: "GE", label: "Genova (province), Liguria" },
  { value: "SP", label: "La Spezia (province), Liguria" },
  { value: "PC", label: "Piacenza (province), Emilia-Romagna" },
  { value: "PR", label: "Parma (province), Emilia-Romagna" },
  { value: "RE", label: "Reggio nell'Emilia (province), Emilia-Romagna" },
  { value: "MO", label: "Modena (province), Emilia-Romagna" },
  { value: "BO", label: "Bologna (province), Emilia-Romagna" },
  { value: "FE", label: "Ferrara (province), Emilia-Romagna" },
  { value: "RA", label: "Ravenna (province), Emilia-Romagna" },
  { value: "FC", label: "Forlì-Cesena (province), Emilia-Romagna" },
  { value: "RN", label: "Rimini (province), Emilia-Romagna" },
  { value: "MS", label: "Massa-Carrara (province), Toscana" },
  { value: "LU", label: "Lucca (province), Toscana" },
  { value: "PT", label: "Pistoia (province), Toscana" },
  { value: "FI", label: "Firenze (province), Toscana" },
  { value: "LI", label: "Livorno (province), Toscana" },
  { value: "PI", label: "Pisa (province), Toscana" },
  { value: "AR", label: "Arezzo (province), Toscana" },
  { value: "SI", label: "Siena (province), Toscana" },
  { value: "GR", label: "Grosseto (province), Toscana" },
  { value: "PO", label: "Prato (province), Toscana" },
  { value: "PG", label: "Perugia (province), Umbria" },
  { value: "TR", label: "Terni (province), Umbria" },
  { value: "PU", label: "Pesaro e Urbino (province), Marche" },
  { value: "AN", label: "Ancona (province), Marche" },
  { value: "MC", label: "Macerata (province), Marche" },
  { value: "AP", label: "Ascoli Piceno (province), Marche" },
  { value: "FM", label: "Fermo (province), Marche" },
  { value: "VT", label: "Viterbo (province), Lazio" },
  { value: "RI", label: "Rieti (province), Lazio" },
  { value: "RM", label: "Roma (province), Lazio" },
  { value: "LT", label: "Latina (province), Lazio" },
  { value: "FR", label: "Frosinone (province), Lazio" },
  { value: "AQ", label: "L'Aquila (province), Abruzzo" },
  { value: "TE", label: "Teramo (province), Abruzzo" },
  { value: "PE", label: "Pescara (province), Abruzzo" },
  { value: "CH", label: "Chieti (province), Abruzzo" },
  { value: "CB", label: "Campobasso (province), Molise" },
  { value: "IS", label: "Isernia (province), Molise" },
  { value: "CE", label: "Caserta (province), Campania" },
  { value: "BN", label: "Benevento (province), Campania" },
  { value: "NA", label: "Napoli (province), Campania" },
  { value: "AV", label: "Avellino (province), Campania" },
  { value: "SA", label: "Salerno (province), Campania" },
  { value: "FG", label: "Foggia (province), Puglia" },
  { value: "BA", label: "Bari (province), Puglia" },
  { value: "TA", label: "Taranto (province), Puglia" },
  { value: "BR", label: "Brindisi (province), Puglia" },
  { value: "LE", label: "Lecce (province), Puglia" },
  { value: "BT", label: "Barletta-Andria-Trani (province), Puglia" },
  { value: "PZ", label: "Potenza (province), Basilicata" },
  { value: "MT", label: "Matera (province), Basilicata" },
  { value: "CS", label: "Cosenza (province), Calabria" },
  { value: "CZ", label: "Catanzaro (province), Calabria" },
  { value: "RC", label: "Reggio di Calabria (province), Calabria" },
  { value: "KR", label: "Crotone (province), Calabria" },
  { value: "VV", label: "Vibo Valentia (province), Calabria" },
  { value: "TP", label: "Trapani (province), Sicilia" },
  { value: "PA", label: "Palermo (province), Sicilia" },
  { value: "ME", label: "Messina (province), Sicilia" },
  { value: "AG", label: "Agrigento (province), Sicilia" },
  { value: "CL", label: "Caltanissetta (province), Sicilia" },
  { value: "EN", label: "Enna (province), Sicilia" },
  { value: "CT", label: "Catania (province), Sicilia" },
  { value: "RG", label: "Ragusa (province), Sicilia" },
  { value: "SR", label: "Siracusa (province), Sicilia" },
  { value: "SS", label: "Sassari (province), Sardegna" },
  { value: "NU", label: "Nuoro (province), Sardegna" },
  { value: "CA", label: "Cagliari (province), Sardegna" },
  { value: "OR", label: "Oristano (province), Sardegna" },
  { value: "OT", label: "Olbia-Tempio (province), Sardegna" },
  { value: "OG", label: "Ogliastra (province), Sardegna" },
  { value: "VS", label: "Medio Campidano (province), Sardegna" },
  { value: "CI", label: "Carbonia-Iglesias (province), Sardegna" },
];

export const US_STATES = [
  { value: "-", label: "select state", isDisabled: true },
  { value: "AL", label: "Alabama" },
  { value: "AK", label: "Alaska" },
  { value: "AS", label: "American Samoa" },
  { value: "AZ", label: "Arizona" },
  { value: "AR", label: "Arkansas" },
  { value: "CA", label: "California" },
  { value: "CO", label: "Colorado" },
  { value: "CT", label: "Connecticut" },
  { value: "DE", label: "Delaware" },
  { value: "DC", label: "District Of Columbia" },
  { value: "FM", label: "Federated States Of Micronesia" },
  { value: "FL", label: "Florida" },
  { value: "GA", label: "Georgia" },
  { value: "GU", label: "Guam" },
  { value: "HI", label: "Hawaii" },
  { value: "ID", label: "Idaho" },
  { value: "IL", label: "Illinois" },
  { value: "IN", label: "Indiana" },
  { value: "IA", label: "Iowa" },
  { value: "KS", label: "Kansas" },
  { value: "KY", label: "Kentucky" },
  { value: "LA", label: "Louisiana" },
  { value: "ME", label: "Maine" },
  { value: "MH", label: "Marshall Islands" },
  { value: "MD", label: "Maryland" },
  { value: "MA", label: "Massachusetts" },
  { value: "MI", label: "Michigan" },
  { value: "MN", label: "Minnesota" },
  { value: "MS", label: "Mississippi" },
  { value: "MO", label: "Missouri" },
  { value: "MT", label: "Montana" },
  { value: "NE", label: "Nebraska" },
  { value: "NV", label: "Nevada" },
  { value: "NH", label: "New Hampshire" },
  { value: "NJ", label: "New Jersey" },
  { value: "NM", label: "New Mexico" },
  { value: "NY", label: "New York" },
  { value: "NC", label: "North Carolina" },
  { value: "ND", label: "North Dakota" },
  { value: "MP", label: "Northern Mariana Islands" },
  { value: "OH", label: "Ohio" },
  { value: "OK", label: "Oklahoma" },
  { value: "OR", label: "Oregon" },
  { value: "PW", label: "Palau" },
  { value: "PA", label: "Pennsylvania" },
  { value: "PR", label: "Puerto Rico" },
  { value: "RI", label: "Rhode Island" },
  { value: "SC", label: "South Carolina" },
  { value: "SD", label: "South Dakota" },
  { value: "TN", label: "Tennessee" },
  { value: "TX", label: "Texas" },
  { value: "UT", label: "Utah" },
  { value: "VT", label: "Vermont" },
  { value: "VI", label: "Virgin Islands" },
  { value: "VA", label: "Virginia" },
  { value: "WA", label: "Washington" },
  { value: "WV", label: "West Virginia" },
  { value: "WI", label: "Wisconsin" },
  { value: "WY", label: "Wyoming" },
];
